"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _mediaTools = require("@evideo/media-tools");

var _lodash = _interopRequireDefault(require("lodash"));

var _vue = require("vue");

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var _default = function _default(workerPublicPath) {
  var audioMixer = (0, _vue.ref)(undefined);
  var isMixer = (0, _vue.ref)(false);
  var playAudioMixerState = (0, _vue.ref)('pause');
  var accAudioBlob = (0, _vue.ref)(undefined);
  var userAudioBlob = (0, _vue.ref)(undefined);
  var userDelay = (0, _vue.ref)(0);
  var accVolume = (0, _vue.ref)(1);
  var userVolume = (0, _vue.ref)(1);
  var mixerDuration = (0, _vue.ref)(0);
  var currentMixerTime = (0, _vue.ref)(0);
  var isAudioMixerPlaying = (0, _vue.ref)(false);
  var lastResultAudio = (0, _vue.ref)(undefined);
  var lastCurrentInfos = (0, _vue.ref)(undefined);

  var mediaGenerator = _mediaTools.MediaGenerator.getDefaultMediaGenerator(workerPublicPath ? {
    log: true,
    pathPrefix: workerPublicPath
  } : {
    log: true
  });

  var timeId = undefined;
  (0, _vue.watch)(function () {
    return userDelay.value;
  }, function (newVal) {
    isMixer.value && changeUserDelay(newVal);
    localStorage.setItem('saveSheetMusicSongScoreInfo', JSON.stringify((0, _extends2.default)((0, _extends2.default)({}, JSON.parse(localStorage.getItem('saveSheetMusicSongScoreInfo'))), {
      userDelay: newVal
    })));
  });
  (0, _vue.watch)(function () {
    return accVolume.value;
  }, function (newVal) {
    isMixer.value && changeAccGain(newVal);
    localStorage.setItem('saveSheetMusicSongScoreInfo', JSON.stringify((0, _extends2.default)((0, _extends2.default)({}, JSON.parse(localStorage.getItem('saveSheetMusicSongScoreInfo'))), {
      accVolume: newVal
    })));
  });
  (0, _vue.watch)(function () {
    return userVolume.value;
  }, function (newVal) {
    isMixer.value && changeUserGain(newVal);
    localStorage.setItem('saveSheetMusicSongScoreInfo', JSON.stringify((0, _extends2.default)((0, _extends2.default)({}, JSON.parse(localStorage.getItem('saveSheetMusicSongScoreInfo'))), {
      userVolume: newVal
    })));
  });
  (0, _vue.watch)(function () {
    return playAudioMixerState.value;
  }, function (newVal) {
    changeAudioMixerPlayState(newVal);
  }, {
    deep: true
  });
  (0, _vue.watch)(function () {
    return currentMixerTime.value;
  }, function () {
    if (currentMixerTime.value && isAudioMixerPlaying.value) {
      if (currentMixerTime.value >= mixerDuration.value) {
        setCurrentMixerTime(0);
        isAudioMixerPlaying.value = false;
        playAudioMixerState.value = 'pause';
      }
    }
  });
  /**
   * 调整伴奏音量
   * 范围0-2
   * **/

  var changeAccGain = function changeAccGain(gain) {
    audioMixer.value.gain1 = gain;
    accVolume.value = gain;
  };
  /**
   * 调整人声音量
   * 范围0-2
   * **/


  var changeUserGain = function changeUserGain(gain) {
    audioMixer.value.gain0 = gain;
    userVolume.value = gain;
  };
  /**
   * 调整人声对齐
   * 范围前后1s，精确到100ms
   * @param delay - 正数:延迟 负数:提前  单位:ms
   */


  var changeUserDelay = function changeUserDelay(delay) {
    audioMixer.value.delay = delay;
  };

  var changeAudioMixerPlayState = function changeAudioMixerPlayState(playState) {
    switch (playState) {
      case 'play':
        audioMixer.value.play();
        isAudioMixerPlaying.value = true;
        playAudioMixerState.value = 'play';
        timeId = setInterval(function () {
          currentMixerTime.value = audioMixer.value.currentTime;
        }, 300);
        break;

      case 'pause':
        playAudioMixerState.value = 'pause';
        audioMixer.value && audioMixer.value.pause();
        timeId && clearInterval(timeId);
        timeId = undefined;
        break;

      default:
        break;
    }
  }; // 音频总时长


  var getDuration = function getDuration() {
    return new Promise(function (resolve) {
      var _a, _b, _c;

      if (((_a = audioMixer.value) === null || _a === void 0 ? void 0 : _a.duration) === Infinity || Number.isNaN((_b = audioMixer.value) === null || _b === void 0 ? void 0 : _b.duration)) {
        // * 得到的音频数据可能没有设置音频长度，因此要简单播放下，再去获取长度
        audioMixer.value.currentTime = 1e101;

        audioMixer.value.ontimeupdate = function () {
          var _a;

          audioMixer.value.ontimeupdate = function () {
            return;
          }; // 不重新设置currtTime,会直接触发audio的ended事件，因为之前将currentTime设置成了一个比音频时长还大的值。所以要将currentTime重置为初始状态。
          // 注: 这里有一个问题，直接设置为0 是不起作用的。需要重新设置一下audio.currentTime = 1e101;然后再设置为


          audioMixer.value.currentTime = 1e101;
          audioMixer.value.currentTime = 0;
          mixerDuration.value = ((_a = audioMixer.value) === null || _a === void 0 ? void 0 : _a.duration) || 0;
          resolve(mixerDuration.value);
        };
      } else {
        mixerDuration.value = ((_c = audioMixer.value) === null || _c === void 0 ? void 0 : _c.duration) || 0;
        resolve(mixerDuration.value);
      }
    });
  }; // 设置当前音频时间，单位为s


  var setCurrentMixerTime = function setCurrentMixerTime(time) {
    currentMixerTime.value = time;
    audioMixer.value.currentTime = time;
  }; // 混音音频 0为用户录音，1为伴奏音频


  var handleMergeAudio = function handleMergeAudio(userAudio, accAudio, startTime) {
    return new Promise(function (resolve, reject) {
      if (!accAudio) {
        audioMixer.value = document.createElement('audio');
        audioMixer.value.src = window.URL.createObjectURL(userAudio);
        isMixer.value = false;
        audioMixer.value.preload = true;

        audioMixer.value.onloadedmetadata = function () {
          console.log('音频加载完毕');
          getDuration();
        };

        resolve('');
      } else {
        audioMixer.value = new _mediaTools.MediaMixer(userAudio, accAudio);
        audioMixer.value.init().then(function () {
          var scoreInfos = JSON.parse(localStorage.getItem('saveSheetMusicSongScoreInfo'));

          var _ref = scoreInfos || {},
              _userDelay = _ref.userDelay,
              _userVolume = _ref.userVolume,
              _accVolume = _ref.accVolume;

          audioMixer.value.delay0 = _userDelay !== undefined ? _userDelay : 0;
          audioMixer.value.delay1 = 0;
          audioMixer.value.gain0 = _userVolume !== undefined ? _userVolume : 1;
          audioMixer.value.gain1 = _accVolume !== undefined ? _accVolume : 1;

          if (startTime) {
            audioMixer.value.delay1 = startTime * -1;
          }

          isMixer.value = true;

          audioMixer.value.onended = function () {
            setCurrentMixerTime(0);
            isAudioMixerPlaying.value = false;
            playAudioMixerState.value = 'pause';
          };

          resolve('');
        }).catch(function (e) {
          audioMixer.value = document.createElement('audio');
          audioMixer.value.src = window.URL.createObjectURL(userAudio);
          isMixer.value = false;
          reject("\u6DF7\u97F3\u5931\u8D25".concat(e));
        });
      }
    });
  }; // 初始化混音


  var initMediaMixer = function initMediaMixer(userAudio, accAudio, startTime) {
    resetAudioMixer();
    userAudioBlob.value = userAudio;
    accAudioBlob.value = accAudio ? accAudio : undefined;
    return new Promise(function (resolve, reject) {
      handleMergeAudio(userAudio, accAudio, startTime).then(function () {
        isAudioMixerPlaying.value = false;
        setTimeout(function () {
          getDuration();
          resolve('');
        }, 200);
      }).catch(function (e) {
        return reject(e);
      });
    });
  }; // 初始化合成音频工具


  var initMediaGenerator = function initMediaGenerator() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return mediaGenerator.load();

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error('ffmpeg加载失败:', _context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));
  }; // 销毁合成音频工具


  var destroyMediaGenerator = function destroyMediaGenerator() {
    if (mediaGenerator) {
      mediaGenerator.close();
      mediaGenerator = undefined;
    }
  }; // 销毁混音实例


  var destroyMediaMixer = function destroyMediaMixer() {
    if (audioMixer.value) {
      audioMixer.value.pause();
      isMixer.value && audioMixer.value.close();
      isAudioMixerPlaying.value = false;
      timeId && clearInterval(timeId);
      timeId = undefined;
    }

    lastCurrentInfos.value = undefined;
    lastResultAudio.value = undefined;
  }; // 重置混音参数


  var resetAudioMixer = function resetAudioMixer() {
    isMixer.value = false;
    audioMixer.value = undefined;
    playAudioMixerState.value = 'pause';
    currentMixerTime.value = 0;
    mixerDuration.value = 0;
    accAudioBlob.value = undefined;
    userAudioBlob.value = undefined;
    isAudioMixerPlaying.value = false;
    timeId = undefined;
  };

  var reMerge = function reMerge(newCurrentInfos) {
    var _a, _b, _c, _d;

    if (!lastCurrentInfos.value) {
      lastCurrentInfos.value = _lodash.default.cloneDeep(newCurrentInfos);
      return true;
    }

    if (((_a = lastCurrentInfos.value) === null || _a === void 0 ? void 0 : _a.volume0) === newCurrentInfos.volume0 && ((_b = lastCurrentInfos.value) === null || _b === void 0 ? void 0 : _b.volume1) === newCurrentInfos.volume1 && ((_c = lastCurrentInfos.value) === null || _c === void 0 ? void 0 : _c.delay0) === newCurrentInfos.delay0 && ((_d = lastCurrentInfos.value) === null || _d === void 0 ? void 0 : _d.delay1) === newCurrentInfos.delay1) {
      return false;
    }

    lastCurrentInfos.value = _lodash.default.cloneDeep(newCurrentInfos);
    return true;
  }; // 合成音频


  var handleMergeSound = function handleMergeSound() {
    return new Promise(function (resolve, reject) {
      var timeId = setTimeout(function () {
        reject('合成音频超时');
      }, 300000);

      if (isMixer.value) {
        var currentInfos = audioMixer.value.getMediaGeneratorMergeSoundOptions();

        if (!reMerge(currentInfos) && lastResultAudio.value) {
          clearTimeout(timeId);
          resolve(lastResultAudio.value);
        } else {
          mediaGenerator.mergeSound(userAudioBlob.value, accAudioBlob.value, {
            volume0: (currentInfos === null || currentInfos === void 0 ? void 0 : currentInfos.volume0) * 1.5,
            volume1: (currentInfos === null || currentInfos === void 0 ? void 0 : currentInfos.volume1) * 1.5,
            delay0: currentInfos === null || currentInfos === void 0 ? void 0 : currentInfos.delay0,
            delay1: currentInfos === null || currentInfos === void 0 ? void 0 : currentInfos.delay1
          }).then(function (resultAudio) {
            lastResultAudio.value = resultAudio;
            clearTimeout(timeId);
            resolve(resultAudio);
          }).catch(function (e) {
            clearTimeout(timeId);
            reject("\u5408\u6210\u97F3\u9891\u5931\u8D25:".concat(e === null || e === void 0 ? void 0 : e.message));
          });
        }
      } else {
        clearTimeout(timeId);
        resolve(userAudioBlob.value);
      }
    });
  };

  (0, _vue.onMounted)(function () {
    if (localStorage.getItem('saveSheetMusicSongScoreInfo')) {
      var scoreInfos = JSON.parse(localStorage.getItem('saveSheetMusicSongScoreInfo'));

      var _ref2 = scoreInfos || {},
          _userDelay = _ref2.userDelay,
          _userVolume = _ref2.userVolume,
          _accVolume = _ref2.accVolume;

      userDelay.value = _userDelay !== undefined ? _userDelay : 0;
      userVolume.value = _userVolume !== undefined ? _userVolume : 1;
      accVolume.value = _accVolume !== undefined ? _accVolume : 1;
    }
  });
  (0, _vue.onBeforeUnmount)(function () {
    changeAudioMixerPlayState('pause');
  });
  return {
    userDelay: userDelay,
    userVolume: userVolume,
    accVolume: accVolume,
    mixerDuration: mixerDuration,
    currentMixerTime: currentMixerTime,
    playAudioMixerState: playAudioMixerState,
    isAudioMixerPlaying: isAudioMixerPlaying,
    setCurrentMixerTime: setCurrentMixerTime,
    initMediaMixer: initMediaMixer,
    initMediaGenerator: initMediaGenerator,
    resetAudioMixer: resetAudioMixer,
    destroyMediaGenerator: destroyMediaGenerator,
    destroyMediaMixer: destroyMediaMixer,
    handleMergeAudio: handleMergeAudio,
    handleMergeSound: handleMergeSound
  };
};

exports.default = _default;